import React, { useState, useLayoutEffect, useEffect } from 'react'
import request from 'meinian-package/src/utils/request'
import util from 'meinian-package/src/utils/util'
import isIPad from 'meinian-package/src/common/isIPad'
import { getUserInfo } from 'meinian-package/src/common/userInfo'
import { picProcess } from 'meinian-package/src/utils/image'
import MessagePanel from './messagePanel'
import OperationPanel from './operationPanel'
import SmallTab from '../../../components/switchTab/smallTab'
import styles from './index.module.less'

const userPanelDate = [
  { label: '本周', value: 'weekly' },
  { label: '本月', value: 'monthly' },
  { label: '本季度', value: 'quarterly' },
  { label: '总计', value: 'totality' },
]

export default () => {
  const userInfo = getUserInfo()
  const [ipadWidth, setIpadWidth] = useState(0)
  const [width, setWidth] = useState(0)
  const [dateType, setDateType] = useState('weekly')
  const [workUserInfo, setWorkUserInfo] = useState({})
  useLayoutEffect(() => {
    const onResize = () => {
      const innerWidth = document.body.clientWidth >= 1366 ? document.body.clientWidth : 1366
      const currentWidth = innerWidth - 808 - 56 - 80 - 48
      setWidth(currentWidth)
      setIpadWidth(document.body.clientWidth - 80 - 48 - 32)
    }
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async (val = dateType) => {
    const result = await request.get('/zhikuan/mn/propagate/collect-statistic-by-date', {
      params: {
        dateType: val,
      },
    })
    setWorkUserInfo(result)
  }

  return (
    <>
      <div className={styles.workPanel}>
        <div className="user-info-panel">
          <div className="user-info-panel-line1">
            <div className="user-info-panel-line1-left">
              <img
                src={
                  picProcess(userInfo.avatar) || 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/avatar.png'
                }
                className="head-picture"
              />
              <span className="user-info-panel-line1-text text-overflow">{userInfo.name}</span>
            </div>
            <div>
              <SmallTab
                options={userPanelDate}
                value={dateType}
                onChange={(val, curTabItem) => {
                  setDateType(val)
                  fetchData(val)
                  util.track('mn-workbench-click', {
                    module1: '采集数据',
                    module2: curTabItem?.label,
                  })
                }}
              />
            </div>
          </div>
          <div className="user-info-panel-line2">
            <div className="user-info-panel-line2-card">
              <div className="user-info-panel-line2-card-text">采集数</div>
              <div className="user-info-panel-line2-card-weight-number">{workUserInfo.blogNum}</div>
              <div className="user-info-panel-line2-card-text mt10">图片数</div>
              <div className="user-info-panel-line2-card-normal-number">{workUserInfo.blogGalleryNum}</div>
            </div>
            <div className="user-info-panel-line2-card">
              <div className="user-info-panel-line2-card-text">商品数</div>
              <div className="user-info-panel-line2-card-weight-number">{workUserInfo.itemNum}</div>
              <div className="user-info-panel-line2-card-text mt10">非商品数</div>
              <div className="user-info-panel-line2-card-normal-number">{workUserInfo.nonItemNum}</div>
            </div>
            <div className="user-info-panel-line2-card">
              <div className="user-info-panel-line2-card-text">已通过</div>
              <div className="user-info-panel-line2-card-weight-number">{workUserInfo.markPassNum}</div>
              <div className="user-info-panel-line2-card-text mt10">通过率</div>
              <div className="user-info-panel-line2-card-normal-number">{(workUserInfo.markPassRatio * 100).toFixed(2)}%</div>
            </div>
          </div>
        </div>
        {isIPad ? (
          <MessagePanel />
        ) : (
          <div className="operation-panel">
            <OperationPanel width={width} workUserInfo={workUserInfo} />
            <MessagePanel />
          </div>
        )}
      </div>
      {isIPad && <OperationPanel width={ipadWidth} wrapStyle={{ marginTop: '16px', width: ipadWidth + 32 }} />}
    </>
  )
}
